































































import { Component, Vue, Ref } from 'vue-property-decorator';

@Component({})
export default class UserProfileChangePassword extends Vue {
  @Ref() readonly form!: {
    setErrors: (any?: any) => void;
    reset: (any?: any) => void;
  };
  old_password = null;
  password = null;
  password_confirmation = null;

  isLoading = false;

  update() {
    this.isLoading = true;
    this.$store
      .dispatch('User/changePassword', {
        id: this.$route.params.userId,
        payload: {
          old_password: this.old_password,
          password: this.password,
          password_confirmation: this.password_confirmation,
        },
      })
      .then(() => {
        this.isLoading = false;
        this.reset();
        this.$store.commit('SET_SNACKBAR', {
          show: true,
          type: 'success',
          message: this.$i18n.t('common_word.success_update'),
        });
      })
      .catch(({ response }) => {
        this.isLoading = false;
        this.form.setErrors(response.data.error);
      });
  }

  reset() {
    this.old_password = null;
    this.password = null;
    this.password_confirmation = null;
    this.form.reset();
  }
}
